"use strict";

const recaptchaContainer = $(".grecaptcha-container");
const recaptchaSettings  = getGRecaptchaConfigurationObject();
const $loginBtns = $(".submit-customer-login, .btn-submit-login");

/**
* Retrieves the reCAPTCHA configuration object
* @returns {Object} - reCAPTCHA configuration object
* @property {boolean} isEnabled - Indicates if reCAPTCHA is enabled
* @property {string} siteKey - The reCAPTCHA site key
* @property {string} isRequiredUrl - The URL for reCAPTCHA requirement
* @property {string} isValidAnswerUrl - The URL for validating reCAPTCHA answer
*/
function getGRecaptchaConfigurationObject() {
    const isEnabled        = recaptchaContainer.length > 0;
    const siteKey          = isEnabled && recaptchaContainer.data("recaptcha-sitekey");
    const isRequiredUrl    = isEnabled && recaptchaContainer.data("recaptcha-url");

    return {
        isEnabled        : !!(isEnabled && siteKey && isRequiredUrl),
        siteKey          : siteKey,
        isRequiredUrl    : isRequiredUrl,
    };
}

/**
* Resets the Google reCAPTCHA widget if it exists on the page
*/
function resetGRecaptcha() {
    if (recaptchaSettings.isEnabled && grecaptcha.getPageId() !== null) {
        toggleDisableOnLoginButtons(true);
        grecaptcha.reset();
    }
}

/**
* Toggles the disabled state of login buttons
* @param {boolean} disabled - whether the buttons should be disabled
* @returns {void}
*/
function toggleDisableOnLoginButtons(disabled) {
    $loginBtns.prop("disabled", disabled);
}

/**
* Renders Google reCAPTCHA if it is required
* @param {Function} callback - the callback function to be executed after rendering reCAPTCHA
*/
function renderGRecaptchaIfRequired(callback) {
    if (recaptchaSettings.isEnabled) {
        if (verifyGRecaptchaAnswer()) {
            return callback();
        }

        $.ajax({
            async: false,
            url: recaptchaSettings.isRequiredUrl,
            method: "POST"
        }).done(function (data) {
            if (data.isRecaptchaRequired) {
                resetGRecaptcha();

                if (!grecaptcha.getPageId()) {
                    toggleDisableOnLoginButtons(true);
                    grecaptcha.render(recaptchaContainer[0], {
                        sitekey: recaptchaSettings.siteKey,
                        lang: "es",
                        callback: () => {
                            toggleDisableOnLoginButtons(false);
                        },
                        "expired-callback": () => {
                            toggleDisableOnLoginButtons(true);
                        }
                    });
                }

                $.spinner().stop();
                return false;
            }

            return callback();
        });

        return false;
    }

    callback();
}

/**
* Verifies the Google reCAPTCHA answer and executes the callback function if the answer is valid
* @param {Function} callback - the callback function to be executed if the reCAPTCHA answer is valid
* @returns {jQuery.Deferred} - a jQuery deferred object representing the result of the reCAPTCHA verification
*/
function verifyGRecaptchaAnswer() {
    return grecaptcha.getPageId() !== null;
}

module.exports = {
    getGRecaptchaConfigurationObject: getGRecaptchaConfigurationObject,
    renderGRecaptchaIfRequired: renderGRecaptchaIfRequired,
    verifyGRecaptchaAnswer: verifyGRecaptchaAnswer,
    resetGRecaptcha: resetGRecaptcha
};
